// extracted by mini-css-extract-plugin
export var group = "contactInfo-module--group--b0c3b";
export var info = "contactInfo-module--info--d7d09";